import styled from "styled-components"
import { Button as antButton} from "antd";
import { rgba } from "config/variable";

const FaxDetailModalStyle = styled.div`
  .detailsblock {
    font-size: 14px;
    padding-right: 10px;
    .heading {
      font-weight: 600;
    }
    .delivered {
      color: ${(props) => props.theme.colorsuccess};
    }
    .deleted{
      color: ${(props) => props.theme.colordanger};
    }
    .sending{
      color: ${(props) => props.theme.primary};
    }
  }
`;

export default FaxDetailModalStyle
export const ActionButton = styled(antButton)`
  &.ant-btn-default {
    border: 1px solid ${(props) => props.theme.bordercolordlightblue};
    background-color: ${(props) => props.theme.bglightblue};
    padding: 0;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    &.delete-icon {
      color: ${(props) => props.theme.colordanger};
      &:hover {
        color: ${(props) => props.theme.colordanger};
      }
    }
    &.ant-dropdown-open {
      color: ${(props) => props.theme.textcolordarkblue};
    }
    &:disabled {
      color: ${(props) => rgba(props.theme.textcolordblack, 0.25)};
    }
  }
`;

